const TeamManagementTypes = {
    FAILED_TEAM_MEMBERS: 'FAILED_TEAM_MEMBERS',
    FETCH_TEAM_MEMBERS: 'FETCH_TEAM_MEMBERS',
    SET_TEAM_MEMBERS: 'SET_TEAM_MEMBERS',
    SUCCESS_TEAM_MEMBERS: 'SUCCESS_TEAM_MEMBERS',
    DELETE_TEAM_MEMBERS: 'DELETE_TEAM_MEMBERS',
    UPDATE_TEAM_ROLE_MEMBERS: 'UPDATE_TEAM_ROLE_MEMBERS',
    INVITE_TEAM_MEMBERS: 'INVITE_TEAM_MEMBERS',
    INVITE_TEAM_MEMBERS_SUCCESS: 'INVITE_TEAM_MEMBERS_SUCCESS',
    INVITE_TEAM_MEMBERS_FAILED: 'INVITE_TEAM_MEMBERS_FAILED',
};
export default TeamManagementTypes;

export interface InvitedTeamMembersPayload {
    investorUUID: string;
    investorList: string[];
}

export interface TeamMember {
    userUUID: string;
    role: string;
    expiry?: string;
    status: string;
    email: string;
    name: string;
    userType: string;
    investorType: string;
    userStatus: string;
    account_type: string;
}

export interface TeamData {
    teamName: string;
    members: TeamMember[];
}

export interface TeamManagementState {
    loading: boolean;
    inviteLoader: boolean;
    teamMemberList: TeamData;
}
